// extracted by mini-css-extract-plugin
module.exports = {"badge":"ListedBadge_badge__Rp-DC","icon":"ListedBadge_icon__10SxU"};